import {LineupsWidgetDisplayAnalyticsEventHandler} from "../../lineups-widget/handlers/lineups-widget.display.analytics-event-handler";

export class BoxScoresWidgetDisplayAnalyticsEventHandler extends LineupsWidgetDisplayAnalyticsEventHandler {}